import { privateAxios } from "@/common/api/axios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseCitiesProps<T> = {
  filters?: {
    search?: string;
    stateId?: string;
  };
  mapper?: (data: any) => T,
};

export const useCities = <T,>({
  filters: { search = '', stateId } = {},
  mapper = Mapper.default<T>(),
}: UseCitiesProps<T>) => {
  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['cities', search, stateId],
    queryFn: () => {
      return privateAxios.get(`/geo/cities`, {
        params: {
          search,
          'q[state_id_eq]': stateId,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
